<template>
  <v-layout v-resize="onResize" column style="padding-top: 0px">
    <div class="container-fluid">
      <div class="row" style="margin-top: 0px">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">Inquiry Tao Yu</div>
            <div class="card-body">
              <v-dialog v-model="dialogLoading" width="150px" height="auto">
                <v-card width="150px" height="150px" style="text-align: center">
                  <v-progress-circular
                    :size="70"
                    :width="7"
                    color="orange"
                    indeterminate
                    persistent
                    style="margin-top: 40px"
                  ></v-progress-circular>
                </v-card>
              </v-dialog>
              <div class="row">
                <div class="col">
                  <v-select
                    :items="listKotaDaftar"
                    label="Kota Domisili"
                    required
                    v-model="search_kota"
                    item-text="DESKRIPSI_DATA"
                    item-value="ID_DATA"
                    color="#F9A825"
                    v-on:change="searchData()"
                  ></v-select>
                </div>
                <div class="col">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="search_tgl_daftar"
                        label="Tao Ying Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        @blur="search_tgl_daftar_raw = parseDate(search_tgl_daftar)"
                        v-on="on"
                        color="#F9A825"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="search_tgl_daftar_raw"
                      v-on:change="searchData()"
                      color="#F9A825"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </div>

              <!-- show-select -->
              <v-data-table
                v-model="dataTables"
                :single-select="singleSelect"
                item-key="ID_TRX"
                :hide-default-header="isMobile"
                :headers="headers"
                :items="users"
                :search="search"
                :class="{mobile: isMobile}"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search Tao Yu Data"
                      single-line
                      hide-details
                      color="#F9A825"
                    ></v-text-field>
                    <v-dialog
                      v-model="dialog"
                      v-if="dialog"
                      max-width="98%"
                      persistent
                    >
                      <v-card>
                        <FormDaftar
                          @onCloseDialog="onCloseDialog"
                          :data="{ editedItem }"
                          :dataKota="{ search_kota }"
                          :dataTanggal="{ search_tgl_daftar_raw }"
                        ></FormDaftar>
                      </v-card>
                    </v-dialog>

                    <v-dialog
                      v-model="dialog2"
                      v-if="dialog2"
                      max-width="98%"
                      persistent
                    >
                      <v-card>
                        <FormGraduateTaoying
                          @onCloseDialog="onCloseDialog"
                          :dataTaoyu="{ users }"
                        ></FormGraduateTaoying>
                      </v-card>
                    </v-dialog>
                    <v-dialog
                      v-model="dialog3"
                      v-if="dialog3"
                      max-width="35%"
                      persistent
                    >
                      <v-card>
                        <FormUploadSignature
                          @onCloseDialog="onCloseDialog"
                          :dataTaoyu="{ users }"
                          :idDatatable="id_data_table"
                        ></FormUploadSignature>
                      </v-card>
                    </v-dialog>

                    <v-dialog
                      v-model="dialog4"
                      v-if="dialog4"
                      max-width="70%"
                      persistent
                    >
                      <DataTableHistory
                      @onCloseDialog="onCloseDialog"
                      :idDatatable="id_data_table2"
                      ></DataTableHistory>
                    </v-dialog>
                    <v-dialog
                      v-model="dialogGenUser"
                      v-if="dialogGenUser"
                      max-width="30%"
                      persistent
                    >
                      <v-card>
                        <v-card-title>
                          How many user that you want to be generated?
                        </v-card-title>
                        <v-card-text>
                          <table>
                            <tr>
                              <td>
                                <v-text-field
                                  v-model="genUser"
                                  label=""
                                  color="#F9A825"
                                ></v-text-field>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style="
                                  vertical-align: bottom;
                                  text-align: right;
                                "
                              >
                                <v-btn
                                  style="margin-right: 20px"
                                  color="#3EB650"
                                  dark
                                  @click="generateUser"
                                  >Generate</v-btn
                                >
                                <v-btn
                                  style="margin-right: 20px"
                                  color="#E57373"
                                  dark
                                  @click="onCloseDialog"
                                  >Cancel</v-btn
                                >
                              </td>
                            </tr>
                          </table>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>

                <template v-slot:item.TGL_DAFTAR="{ item }">
                  <span
                    >{{ new Date(item.TGL_DAFTAR).toLocaleDateString('es-CL') }}</span
                  >
                </template>

                <template v-slot:item.updated_at="{ item }">
                  <span
                    >{{ new Date(item.updated_at).toLocaleString('es-CL') }}</span
                  >
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="editItem(item)">
                    mdi-pencil
                  </v-icon>
                  <v-icon small class="mr-2" @click="deleteItem(item)">
                    mdi-delete
                  </v-icon>
                  <v-icon small class="mr-2" @click="printProfile(item)">
                    mdi-printer
                  </v-icon>
                  <v-icon small class="mr-2" @click="uploadSignature(item)">
                    mdi-upload
                  </v-icon>
                  <v-icon small class="mr-2" @click="showHistory(item)">
                    mdi-history
                  </v-icon>
                </template>
                <template v-slot:no-data>
                  <!-- <v-btn color="#FCC133" @click="initialize">Reset</v-btn> -->
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
import axios from '@/axios'
import FormDaftar from '../../components/modal/FormDaftar.vue'
import FormGraduateTaoying from '../../components/modal/FormGraduateTaoying.vue'
import FormUploadSignature from '../../components/modal/FormUploadSignature.vue'
import DataTableHistory from '../../components/modal/DataTableHistory.vue'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
export default {
    data: () => ({
        sortBy: 'NO_TAOYU',
        sortDesc: false,
        search: '',
        isMobile: false,
        search_kota:'',
        search_tgl_daftar:'',
        search_tgl_daftar_raw:'',
        dialog: false,
        dialog2: false,
        dialog3: false,
        dialog4: false,
        dialogLoading: false,
        dialogGenUser:false,
        listKotaDaftar:[],
        menu2:false,
        headers: [
        { text: 'Name', align: 'start',value: 'NAMA_INDO',},
        { text: 'Chinese Name (Pinyin)', value: 'NAMA_PINYIN' },
        { text: 'Chinese Name (Hanzi)', value: 'NAMA_HANZI' },
        { text: 'Tao Ying Date', value: 'TGL_DAFTAR', filterable: false },
        // { text: 'Updated By', value: 'NO_TAOYU', filterable: false },
        { text: 'Created By', value: 'LAST_UPDATE_NAME', filterable: false },
        { text: 'Last Updated', value: 'updated_at', filterable: false },
        { text: 'Actions', value: 'actions', sortable: false },
        ],
        users:[],
        editedIndex: -1,
        editedItem: [],
        flagEdited:false,
        role:0,
        statusDialog:0,
        singleSelect: false,
        dataTables: [],
    }),
    computed: {
        // formTitle () {
        //     return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
        // },
    },
    watch: {
        dialog (val) {val || this.close()},
        dialog2 (val) {val || this.close()},
        search_tgl_daftar_raw (val) {
            this.search_tgl_daftar = this.formatDate(this.search_tgl_daftar_raw)
            // new Date(this.search_tgl_daftar_raw).toLocaleDateString('es-CL')
        },
    },
    created () {
         if(this.search_kota!=='' || this.search_tgl_daftar_raw!==''){

              this.searchData()
            }else{
                console.log('aneh')
                console.log(this.search_tgl_daftar_raw)
                this.initialize() 
            }
    },
    beforeCreate: function () {
        if (!this.$session.exists()) {
        this.$router.push('/')
        }
    },
    methods: {
        onResize() {
          if (window.innerWidth < 769)
            this.isMobile = true;
          else
            this.isMobile = false;
        },
        initialize () {
            // console.log('Dash '+this.$session.get('token'));
            if(this.$session.get('role'))this.role=this.$session.get('role');

            if(this.role=='1' || this.role=='2' || this.role == '6' || this.role == '8'){
                this.users=[];
                axios({
                    method: 'post',
                    url: 'list_data_table',
                    data: {
                      role_name: 'AdminDomisiliTaoyu',
                      user_id:this.$session.get('user_id')
                    },
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    // console.log(JSON.stringify(response.data));
                    this.users=response.data;
                }).catch(error=>{
                    console.log('Error Fetch Data '+error);
                    // var status = error.response.status
                });
            }else{

            }

            if(this.listKotaDaftar.length==0){
                    // sd6webdev.indomaret.lan/laravel-passport/public/api/master_data',
                axios({
                    method: 'post',
                    url: 'get_list_kota_domisili',
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                    data:{
                        user_id: this.$session.get('user_id')
                    }
                }).then(response => {
                    this.listKotaDaftar=response.data;
                }).catch(error=>{
                     // Swal.fire({
                     //            title:'Peringatan',
                     //            icon :'error',
                     //            text:'Failed to retrieve List City !'
                     //    });
                });

            }
        },

        export_data(){
            const swalWithBootstrapButtons = Swal.mixin({
                                              customClass: {
                                                confirmButton: 'btn btn-success',
                                                cancelButton: 'btn btn-danger'
                                              },
                                              buttonsStyling: false
                                            })

            swalWithBootstrapButtons.fire({
             // title: 'Are you sure?',
              text: "Are you sure?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, export to csv!',
              cancelButtonText: 'No, cancel!',
              reverseButtons: true
            }).then((result) => {
              if (result.isConfirmed) {
                axios({
                    method: 'get',
                    url: 'export_all_data_taoyu',
                    responseType: 'blob', // important
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                  }).then(response => {
                      const url = window.URL.createObjectURL(new Blob([response.data]));
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute('download', 'ExportAllData.csv');
                      document.body.appendChild(link);
                      link.click();
                      this.dialogLoading=false;
                  }).catch(error => {
                      console.log(error.response);
                      this.dialogLoading=false;
                  });
              } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
              ) {
                swalWithBootstrapButtons.fire(
                  'Cancelled',
                  'It is okay :)',
                  'info'
                )
                 this.dialogLoading=false;
              }
            })
            
        },
        formatDate (date) {
            if (!date) return null

            return new Date(date).toLocaleDateString('es-CL');
        },
        parseDate (date) {
            if (!date) return null

            return new Date(date).toLocaleDateString('sv-SE')
            // return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        searchData(){
            // alert(this.search_kota+' '+this.search_tgl_daftar_raw);
            // alert('Search Here '+this.search_kota+' '+this.search_tgl_daftar_raw);

            if(this.search_kota!=='' || this.search_tgl_daftar_raw!==''){
                // alert("here");
                axios({
                    method: 'post',
                    url: 'get_data_taoyu_domisili',
                    data: {
                      kota: this.search_kota,
                      tanggal: this.search_tgl_daftar_raw,
                      nomor_taoyu: this.search
                    },
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    this.users=response.data;
                }).catch(error=>{
                    console.log('Error Fetch Data '+error);
                    // var status = error.response.status
                });
            }
        },
        editItem (item) {
            this.flagEdited=true;
            this.editedIndex = this.users.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },
        deleteItem (item) {

            confirm('Are you sure to delete this data?') &&
            axios({
                method: 'post',
                url: 'delete_data_table',
                data: {
                  id: item.ID_TRX,
                },
                headers: {
                  Authorization: 'Bearer ' + this.$session.get('token'),
                },
            }).then(response => {
                if(response.data){
                      Swal.fire({
                                title:'Peringatan',
                                icon :'success',
                                text:response.data
                        });
                    this.initialize()
                }
                console.log(response);
            }).catch(error => {
                console.log(error.response);
            });
        },
        close () {
            this.dialog = false
            this.$nextTick(() => {
            // this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
            })
        },
        newuser(){
            if(!this.search_kota || !this.search_tgl_daftar){
                if(!this.search_kota){
                    Swal.fire({
                                title:'Peringatan',
                                icon :'warning',
                                text:'Kota wajib di-isi'
                        });
                }
                else if(!this.search_tgl_daftar){
                     Swal.fire({
                                title:'Peringatan',
                                icon :'warning',
                                text:'Tanggal wajib di-isi'
                        });
                 }
            }else{
                this.flagEdited=false;
                // alert(JSON.stringify(this.defaultItem));
                // this.editedItem=Object.assign({}, this.defaultItem);
                this.$nextTick(() => { this.dialog=true; });
            }
        },
        graduatetao(){
            if(this.users!=[]){
                this.$nextTick(() => { this.dialog2=true; });
            }else {
                Swal.fire({
                                title:'Peringatan',
                                icon :'warning',
                                text:'Data Tao Yu Kosong'
                        });
            }
            // this.dialog2=true;
        },
        openModalUser(){
            this.dialogGenUser=true;
            this.genUser=0;
        },
        generateUser(){
            // alert('Proses generate User');

            // let user = Math.floor(Date.now() / 1000);
            if(this.genUser>0){
                axios({
                    method: 'post',
                    // url: 'register',
                    url: 'register_more_than_1',
                    responseType: 'blob', // important
                    data: {
                      // name: 'user'+user,
                      // password: 'Tao'+user
                      count_user: this.genUser
                    },
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                        // alert(response.data);
                    if(response){
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'ListUser.pdf');
                        document.body.appendChild(link);
                        link.click();
                    }
                }).catch(error => {

                 Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:error.message
                        });
                    // console.log(error.response);
                });
            }else{
                 Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:'Failed to generate user.'
                        });
            }
        },
        onCloseDialog(){
            // console.log('Close kah ?');
            
            if(this.search_kota!=='' || this.search_tgl_daftar_raw!==''){

              this.searchData()
            }else{
                console.log('aneh')
                console.log(this.search_tgl_daftar_raw)
                this.initialize() 
            }
            this.dialog2=false;
            this.dialog=false;
            this.dialog3=false;
            this.dialog4=false;
            this.dialogGenUser=false;
        },
        printProfile(item){
            this.dialogLoading=true;
            console.log(item);
            const swalWithBootstrapButtons = Swal.mixin({
                                              customClass: {
                                                confirmButton: 'btn btn-success',
                                                cancelButton: 'btn btn-danger'
                                              },
                                              buttonsStyling: false
                                            })

            swalWithBootstrapButtons.fire({
             // title: 'Are you sure?',
              text: "Are you sure?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, download pdf!',
              cancelButtonText: 'No, cancel!',
              reverseButtons: true
            }).then((result) => {
              if (result.isConfirmed) {
                axios({
                    method: 'post',
                    url: 'profile_data',
                    responseType: 'blob', // important
                    data:{
                        id: item.ID_TRX
                    },
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    // console.log(response);
                    if(response){
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', item.NAMA_INDO+'.pdf');
                        document.body.appendChild(link);
                        link.click();
                        this.dialogLoading=false;
                        // this.initialize();
                    }
                }).catch(error => {
                    this.dialogLoading=false;
                    console.log(error.response);
                });
              } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
              ) {
                swalWithBootstrapButtons.fire(
                  'Cancelled',
                  'It is okay :)',
                  'info'
                )
                this.dialogLoading=false;
              }
            })
            // this.dialogLoading=true;
            // confirm('Are you sure to print this profile ?') &&
            // axios({
            //     method: 'post',
            //     url: 'profile_data',
            //     responseType: 'blob', // important
            //     data:{
            //         id: item.ID_TRX
            //     },
            //     headers: {
            //       Authorization: 'Bearer ' + this.$session.get('token'),
            //     },
            // }).then(response => {
            //     // console.log(response);
            //     if(response){
            //         const url = window.URL.createObjectURL(new Blob([response.data]));
            //         const link = document.createElement('a');
            //         link.href = url;
            //         link.setAttribute('download', item.NAMA_INDO+'.pdf');
            //         document.body.appendChild(link);
            //         link.click();
            //         this.dialogLoading=false;
            //         // this.initialize();
            //     }
            // }).catch(error => {
            //     this.dialogLoading=false;
            //     console.log(error.response);
            //});
        },
        showHistory(item){
          this.id_data_table2 = item.ID_TRX;
          this.dialog4 = true;
        },
        uploadSignature (item){
          this.id_data_table = item.ID_TRX;
          this.dialog3=true;
        },

    },
    components: {
        FormDaftar,
        FormGraduateTaoying,
        FormUploadSignature,
        DataTableHistory
        // FormValidasi,
    },
}
</script>

<style>
.butt {
  padding: 10px;
  background-color: #ebaa1f;
}

.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid cyan;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
}
</style>
